import React from 'react';
import { JobsListThird } from './JobsListThird';

export const JobsListsThird = () => {
    return (
        <div>
            <JobsListThird />
        </div>
    );
};
